<template>
  <component 
    :is="currentWidget"
    v-bind="widgetProps"
    @close="handleClose"
    @open="handleOpen"
    @chat-clicked="handleChatClicked"
  />
</template>

<script>
import { computed, onMounted } from 'vue';
import { useDeviceDetection } from '@/composables/chat/useDeviceDetection';
import { useChatWidget } from '@/composables/chat/useChatWidget';
import MobileWidget from './widgets/MobileWidget.vue';
import DesktopWidget from './widgets/DesktopWidget.vue';

export default {
  name: 'ChatWidget',
  components: {
    MobileWidget,
    DesktopWidget
  },
  props: {
    position: {
      type: String,
      default: 'bottom-right',
      validator: (value) => ['bottom-right', 'bottom-left'].includes(value)
    },
    theme: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'minimal', 'branded'].includes(value)
    },
    showWelcomeMessage: {
      type: Boolean,
      default: true
    },
    autoShowDelay: {
      type: Number,
      default: 15000
    },
    phoneNumber: {
      type: String,
      default: '(954) 840-8866'
    },
    emailAddress: {
      type: String,
      default: 'policychanges@insuranceexpress.com'
    },
    businessHours: {
      type: String,
      default: 'Mon-Fri 9AM-5PM EST'
    }
  },
  emits: ['close', 'open', 'chat-clicked'],
  setup(props, { emit }) {
    // Device detection
    const { shouldUseMobileWidget, shouldUseDesktopWidget, deviceContext } = useDeviceDetection();
    
    // Chat initialization
    const { initializeChatwoot } = useChatWidget();

    // Determine which widget to use
    const currentWidget = computed(() => {
      return shouldUseMobileWidget.value ? 'MobileWidget' : 'DesktopWidget';
    });

    // Props to pass to child widgets
    const widgetProps = computed(() => ({
      theme: props.theme,
      phoneNumber: props.phoneNumber,
      emailAddress: props.emailAddress,
      businessHours: props.businessHours
    }));

    // Event handlers
    const handleClose = () => {
      emit('close');
    };

    const handleOpen = () => {
      emit('open');
    };

    const handleChatClicked = () => {
      emit('chat-clicked');
    };

    // Initialize chat on mount
    onMounted(() => {
      initializeChatwoot();
    });

    return {
      currentWidget,
      widgetProps,
      handleClose,
      handleOpen,
      handleChatClicked
    };
  }
};
</script>

<style scoped>
/* Container-specific styles if needed */
</style> 